
import Vue from 'vue';
import { ROUTER } from '@/router/constants';
import { mapGetters, mapState } from 'vuex';
import pluralize from 'pluralize';
import EnterpriseUpsellWrapper from '@/components/EnterpriseUpsellWrapper/EnterpriseUpsellWrapper.vue';

export default Vue.extend({
	name: 'ReportingAnalyticsCard',
	props: {
		showEnterpriseUpsellUi: { type: Boolean, default: false },
		reportingTeam: { type: Object, default: null },
		reportingCompany: { type: Object, default: null },
		reportingTeamMember: { type: Object, default: null },
		backgroundColor: { type: String, default: 'var(--grey-700)' },
		backgroundColorSecondGradient: { type: String, default: 'var(--grey-800)' },
	},
	computed: {
		...mapState([
			'isAdminProxyingUser',
			'user',
		]),
		...mapGetters([
			'displayLabels',
		]),
		descriptionHtml () {
			if (this.reportingTeamMember) {
				return `View detailed usage reports filtered to <b style="font-size: larger">${this.reportingTeam?.name || `this ${this.displayLabels.team}`}</b> and <b style="font-size: larger">${this.reportingTeamMember.email}</b>`;
			}
			if (this.reportingCompany) {
				return `View detailed usage reports for <b style="font-size: larger">All ${pluralize(this.displayLabels.team)}</b>`;
			}
			if (this.reportingTeam) {
				return `View detailed usage reports filtered to <b style="font-size: larger">${this.reportingTeam.name}</b>`;
			}
			return `View detailed usage reports`;
		},
	},
	methods: {
		onCardClick () {
			if (this.showEnterpriseUpsellUi && !this.user?.isAdmin && !this.isAdminProxyingUser) return;

			this.routerPush(this.$route, this.$router, {
				name: ROUTER.COMPANY_USAGE_REPORT,
				query: {
					...(this.reportingTeam && {
						teamId: this.reportingTeam.id,
					}),
					...(this.reportingCompany && {
						companyId: this.reportingCompany.id,
					}),
					...(this.reportingTeamMember && {
						teamMemberEmail: this.reportingTeamMember.email,
					}),
				},
			});
		},
	},
	components: {
		EnterpriseUpsellWrapper,
	},
});
